import React from 'react';
import { FilterOption } from '../../../types';
import { CommonModelsWrapper } from './ModelFamilySelector.style';
import CheckboxSelector from '../../CheckboxComponent';

interface CommonModelsFilter {
  commonModelFamilyOptions: {
    [key: string]: FilterOption;
  };
  selectedModelFamilyFilters: string[];
  availableFilters: string[];
  onChange: (newValue: string) => void;
  filterType: string;
}

const CommonModelsList: React.FC<CommonModelsFilter> = ({
  commonModelFamilyOptions,
  selectedModelFamilyFilters,
  availableFilters,
  onChange,
  filterType,
}) => {
  return (
    <CommonModelsWrapper data-testid="common-model-list-group">
      {Object.keys(commonModelFamilyOptions).map((option) => {
        const model = commonModelFamilyOptions[option];
        return (
          <CheckboxSelector
            inputName={`common-${model.value}`}
            key={model.value}
            onChange={() => onChange(model.value)}
            value={model.value}
            label={model.label}
            ariaLabel={model.ariaLabel}
            checked={selectedModelFamilyFilters.includes(model.value)}
            disabled={!availableFilters.includes(model.value)}
            filterType={filterType}
          />
        );
      })}
    </CommonModelsWrapper>
  );
};

export default CommonModelsList;
